<template>
	<div>
		<Loader :esActiva="mostrar_loader" />
		<Carrusel
			v-if="marcas_por_zona.length > 0"
			:marcas="marcas_por_zona"
			@update_modal_marcas="
				(valor) => {
					mostrar_marcasXDistribuidor(valor);
				}
			"
		/>
		<br />
		<template>
			<v-dialog v-model="dialog" max-width="500px">
				<v-card>
					<v-container class="grey lighten-5">
						<div class="text-center">
							<v-img
								v-if="distribuidor_popup.img_url"
								:src="distribuidor_popup.img_url"
								aspect-ratio="1"
								class="text-center grey"
								style="
									max-width: 197px;
									max-height: 121px;
									width: 100%;
									height: 91px;
									margin-left: auto;
									margin-right: auto;
									display: block;
								"
								@click="seleccionar(distribuidor_popup)"
								justify="center"
							/>
							{{ distribuidor_popup.nombre_distribuidor }}
						</div>
						<v-divider></v-divider>
						<div class="text-center" style="margin-top: 10px">
							También puedes comprar en este distribuidor
						</div>
						<v-row>
							<v-col
								v-for="item in this.marcas_popup"
								:key="item.codigo"
								justify="start"
							>
								<v-img
									style="
										margin-right: 10px;
										cursor: pointer;
										max-height: 100px;
										max-width: 120px;
									"
									:src="item.url_imagen"
									aspect-ratio="1"
									class="grey lighten-3"
									@click="seleccionar(distribuidor_popup)"
								/>
							</v-col>
						</v-row>
					</v-container>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="cerrardialog()">
							<v-icon left>mdi-close</v-icon>Cerrar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</template>
		
		<v-layout
			wrap
			class="mt-2 mb-12 pb-12 px-5"
		>
			<v-flex
				xs6
				lg4
				v-for="distribuidor in distribuidores"
				v-bind:key="distribuidor._id"
			>
				<div class="mx-1">
					<v-card class="mx-4 my-3 pwst_box_shadow" flat>
						<v-row
							align="center"
							@click.stop="seleccionar(distribuidor)"
							style="cursor: pointer"
							justify="center"
						>
							<v-col cols="12 my-0" sm="6">
								<v-img
									:src="distribuidor.img_url"
									class="grey lighten-2"
									:class="[vista_movil ? 'ml-0' : 'ml-6']"
									width="100%"
									height="90"
								></v-img>
							</v-col>
							<v-col cols="12" sm="6" class="text-center">
								<p>
									{{ distribuidor.nombre_distribuidor }}
								</p>
							</v-col>
						</v-row>
					</v-card>
				</div>
			</v-flex>
		</v-layout>
		<v-layout
			row
			justify-center
			align-center
			class="mt-2 mb-12 pb-12 px-5"
			v-if="!mostrar_loader && !distribuidores.length"
		>
			<v-alert
				cols="12"
				border="left"
				colored-border
				type="warning"
				elevation="2"
			>
				Lo sentimos no encontramos distribuidores en tu zona.
			</v-alert>
		</v-layout>
		<ModalIngresarContrasenia
			:esActiva="modal_contrasenia"
			:contrasenia="contrasenia"
			@respuesta_modal_contrasenia="validacion"
		/>
	</div>
</template>
<script>
import Conexion_api from "@/api/Conexion_api.js";
import Vista from "@/objetos/vista";
import Usuario from "@/objetos/usuario";
import redireccionar from "@/funciones/redireccionar";
import Loader from "@/components/Loader/Loader.vue";
import Carrusel from "@/components/SeleccionarDistribuidor/Carrusel.vue";
import ModalIngresarContrasenia from "@/components/ModalIngresarContrasenia/ModalIngresarContrasenia.vue";
import manejador_push from "@/funciones/push/manejador_push";
import obtener_configuracion_contrasena from "@/funciones/obtener_configuracion_contrasena";

//import { SplitCarousel, SplitCarouselItem } from "vue-split-carousel";

export default {
	data: () => ({
		distribuidores: [],
		mostrar_loader: false,
		marcas_por_distribuidor: [],
		marcas_por_zona: [],
		marcas_popup: [],
		distribuidor_popup: {},
		zonas: [],
		displayAmount: 4,
		dialog: false,
		modal_contrasenia: false,
		token: {},
		distribuidor: {},
		contrasenia: "",
	}),
	computed: {
		vista_movil () {
			let vista = this.$vuetify.breakpoint.name;
			let margen_img;
			if(vista === "xs") margen_img = true;
			return margen_img
		}
	},
	created() {
		Vista.nombre = "/distribuidor";
		this.traer_datos();
		this.traer_marcasXdistribuidor();
	},
	components: {
		Loader,
		Carrusel,
		ModalIngresarContrasenia
		// SplitCarousel,
		// SplitCarouselItem
	},
	methods: {
		validacion(valor){ 
			if(valor){
				this.continuar_ejecucion(this.token, this.distribuidor);
				this.modal_contrasenia = false;
			}else {
				this.modal_contrasenia = false
				this.token = {}
				this.distribuidor = {}
			}
		},
		async seleccionar(distribuidor) {
			this.dialog = false;
			this.mostrar_loader = true;
			this.obtener_config = obtener_configuracion_contrasena.bind(this);
      await this.obtener_config(distribuidor)
			let respuesta = await Conexion_api({
				body: {
					correo: Usuario.correo,
					distribuidora: distribuidor.base,
					nombre_distribuidora: distribuidor.nombre_distribuidor,
					validar_contrasenia: distribuidor.contrasenia,
				},
				evento: "login/generar_token",
			}).catch((err) => {
				this.mostrar_loader = false;
				err = String(err);
				this.$root.$emit("snackbar", { color: "error", texto: err });
				console.error(err);
				return;
			});

			this.mostrar_loader = false;
			if (respuesta.data.error) {
				this.$root.$emit("snackbar", {
					color: "error",
					texto: respuesta.data.error,
				});
				return;
			}
			this.contrasenia = respuesta.data.contrasenia
			if (distribuidor.contrasenia && this.contrasenia) {
				this.token = respuesta;
				this.distribuidor = distribuidor;
				this.modal_contrasenia = true;
				return
			}

			/**
			 * SE LANZA PETICIÓN PARA PERMITIR NOTIFICACIONES,
			 * SI YA ESTA ACTIVO, CAMBIA AL DISTRIBUIDOR SELECCIONADO
			 */
			this.continuar_ejecucion(respuesta, distribuidor);
		},
		async continuar_ejecucion(respuesta, distribuidor){
			let bases = this.distribuidores.map((el) => el.base);
			localStorage.setItem("dbs", bases);

			let notificaciones = await manejador_push({ base: distribuidor.base, email: Usuario.correo, bases: this.distribuidores});
			if (notificaciones)
				this.$root.$emit("snackbar", {
					color: "#4CAF50",
					texto: notificaciones,
				});

			this.$cookie.set("pwst", respuesta.data.token, { expires: "1h" });
			this.token = {},
			this.distribuidor = {}
			redireccionar("/pedidos_web");
			return;
		},
		traer_datos() {
			this.mostrar_loader = true;
			Conexion_api({
				body: {
					coordenadas: Usuario.coordenadas,
				},
				evento: "configuraciones_generales/obtener_zonas_cliente",
			})
				.then((respuesta) => {
					this.mostrar_loader = false;
					if (respuesta.data.error) {
						this.$root.$emit("snackbar", {
							color: "error",
							texto: respuesta.data.error,
						});
						return;
					}
					this.distribuidores = respuesta.data.datos.zonas;
				})
				.catch((err) => {
					this.mostrar_loader = false;
					err = String(err);
					this.$root.$emit("snackbar", { color: "error", texto: err });
					console.error(err);
				});
		},
		traer_marcasXdistribuidor() {
			//obtener las marcas seleccionadas x distribuidor
			Conexion_api({
				body: {
					paginado: false,
				},
				evento: "configuraciones_generales/obtener_zonas_cliente",
			})
				.then((respuesta) => {
					if (respuesta.data.error) {
						this.$alertify.error(respuesta.data.error);
						return;
					}
					this.marcas_por_distribuidor =
						respuesta.data.datos.marcas_por_distribuidor;
					this.marcas_por_zona = respuesta.data.datos.marcas_por_zona;
					this.zonas = respuesta.data.datos.zonas;

					if (this.marcas_por_zona.length > 6) {
						this.displayAmount = 6;
					}
				})
				.catch((err) => {
					err = String(err);
					console.error(err);
				});
		},
		mostrar_marcasXDistribuidor(marca) {
			this.marcas_popup = [];
			//        console.log("mostrar marcas para el Distribuidor:", marca.codigo);
			this.dialog = !this.dialog;
			let result = {};
			//devolver el distribuidor y las marcas
			console.log(this.marcas_por_distribuidor);
			this.marcas_por_distribuidor.forEach((distribuidor) => {
				//          console.log("Distribuidor: ",distribuidor);
				distribuidor.marcas.forEach((element) => {
					if (marca.codigo == element.codigo) {
						result = distribuidor;
					}
				});
			});
			//        console.log("Result: ",result);
			result.marcas.forEach((element) => {
				if (marca.codigo != element.codigo) {
					this.marcas_popup.push(element);
				}
			});

			this.distribuidores.forEach((element) => {
				if (element.base == result.distribuidor) {
					this.distribuidor_popup = element;
				}
			});
			//        console.log("Distribuidor: ",this.distribuidor_popup);
			return result;
		},
		cerrardialog() {
			this.dialog = false;
		},
	},
};
</script>